module.exports = __webpack_public_path__ + "img/ic-narrow-right.939b9f1d.svg";